var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',[_c('avatar',{attrs:{"user-id":_vm.value,"show-name":true,"small":true,"hide-avatar":true,"textonly":_vm.textonly}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }